'use strict';

var _ = require('lodash');
var CompetitorFaresChartController = function CompetitorFaresChartController($rootScope, $scope, constants) {
  $scope.label = 'Competitor Fares Profile';
  $scope.timeWindowLabel = '';
  $scope.isFlightMode = $scope.screen === constants.FLIGHT_SCREEN;
  $scope.expandChart = function () {
    $rootScope.$broadcast('profile-chart-panel:swap', true, {
      primaryEntity: $scope.primaryEntity,
      screenMode: constants.FLIGHT_ANALYSIS_MODE,
      selectedMetric: $scope.metrics.selectedMetric,
      target: 'flight-profile-chart',
      screen: $scope.screen,
      mode: constants.CABIN_MODE,
      subMode: constants.FLIGHT_CABIN_PROFILE_MODE
    });
  };
  $scope.$watchGroup(['chartData.data', 'chartData.isSidebarVisible'], function (newValues, oldValues) {
    if (!_.isEqual(newValues[0], oldValues[0]) || !_.isEqual(newValues[1], oldValues[1])) {
      $scope.renderChart($scope.chartData.data);
    }
  });
};
CompetitorFaresChartController.$inject = ['$rootScope', '$scope', 'DataRetrieverConstantsService'];
module.exports = CompetitorFaresChartController;